module.exports = __webpack_public_path__ + "img/392-fb6bab.png";